import React, { Fragment } from 'react';
import { t, Trans } from '@lingui/macro';
import { List, Heading, Paragraph } from '@mos-cat/typography';
import Link from '../components/shared/Link/Link';

import { i18n } from '../helpers/i18n';
import {
  APPLICANT_FIELD_NAME,
  CHILD_FIELD_NAME,
  PERSON_FIELD_NAME,
  SPOUSE_FIELD_NAME,
} from './fieldNames';

export const aboutServiceTexts = [
  t`Данная услуга позволяет подать заявление на присвоение или продление статуса многодетной семьи города Москвы. Заявление может быть подано только одним из родителей (единственным родителем), при условии совместного проживания с детьми.`,
];
export const needToKnow = [
  {
    url: t`https://www.mos.ru/otvet-socialnaya-podderjka/lgoti-mnogodetnim-semyam/`,
    name: t`Льготы для многодетных семей`,
  },
  {
    url: t`https://www.mos.ru/otvet-socialnaya-podderjka/list-vse-dlya-semey-s-detmi-denezhnye-vyplaty-lgoty-socialnaya-podderzhka/`,
    name: t`Всё для семей с детьми`,
  },
  {
    url: t`https://www.mos.ru/services/catalog/cat/54532/item/61532/`,
    name: t`Услуги для многодетных семей`,
  },
];
export const whatIsNextItems = [
  <Trans key={1}>
    Заявление будет передано на регистрацию в ГКУ "Социальное казначейство
    города Москвы".
  </Trans>,
  <Trans key={2}>
    В течение 10 рабочих дней с момента регистрации будет предоставлено решение
    по оказанию услуги. Предоставление услуги может быть приостановлено на срок
    до 10 рабочих дней, если потребуются оригиналы документов. Вы сможете
    предоставить документы в любой удобный для вас{' '}
    <Link
      target="_blank"
      rel="noopener noreferrer"
      href={i18n._(t`https://www.mos.ru/pgu/ru/md/`)}
    >
      Центр предоставления государственных услуг города Москвы «Мои документы»
    </Link>
    .
  </Trans>,
  <Trans key={3}>
    Ход предоставления государственной услуги вы можете отслеживать в{' '}
    <Link
      target="_blank"
      rel="noopener noreferrer"
      href={i18n._(t`https://my.mos.ru/my/`)}
    >
      Личном кабинете
    </Link>
    .
  </Trans>,
];
export const aboutServiceCollapsible = [
  {
    anchor: 'infoAbout1',
    title: <Trans>Кто может обратиться</Trans>,
    text: (
      <Fragment>
        <Paragraph>
          <Trans id="mainPage/serviceInfo/whoCanApply/paragraph/1">
            В качестве заявителя могут выступать один из родителей (единственный
            родитель), а также отчим, мачеха многодетной семьи из числа граждан
            Российской Федерации, иностранных граждан и лиц без гражданства,
            имеющий место жительства в городе Москве.
          </Trans>
        </Paragraph>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout2',
    title: <Trans>Стоимость услуги и порядок оплаты</Trans>,
    text: <Trans>Бесплатно</Trans>,
  },
  {
    anchor: 'infoAbout3',
    title: (
      <Trans id="mainPage/serviceInfo/requiredDocuments/title">
        Перечень необходимых сведений
      </Trans>
    ),
    text: (
      <Fragment>
        <List className="InfoAboutService__unorderedList InfoAboutService__nestedList">
          <List.Item className="InfoAboutService__orderedListItem">
            Паспорт заявителя
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Правоустанавливающие документы, выданные за пределами Российской
            Федерации (свидетельство о заключении брака, об изменении ФИО,
            свидетельство о рождении ребенка и др.);
          </List.Item>
        </List>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout4',
    title: (
      <Trans id="mainPage/serviceInfo/serviceDeliveryTime/title">
        Сроки предоставления услуги
      </Trans>
    ),
    text: (
      <Fragment>
        <Paragraph>10 рабочих дней.</Paragraph>
        <Paragraph>
          Предоставление услуги может приостанавливаться на 10 рабочих дней для
          необходимости представления документов личного хранения или
          документов, сведения о которых не могут быть получены в рамках
          межведомственного взаимодействия, на бумажном носителе в любой МФЦ
          города Москвы
        </Paragraph>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout5',
    title: 'Результат оказания услуги',
    text: (
      <Paragraph>
        О результате оказания услуги будет проинформирована через «личный
        кабинет» на{' '}
        <Link href="https://www.mos.ru/" target="_blank">
          mos.ru
        </Link>
      </Paragraph>
    ),
  },
  {
    anchor: 'infoAbout6',
    title: 'Формы получения',
    text: (
      <Paragraph>
        В электронном виде через «личный кабинет» на{' '}
        <Link href="https://www.mos.ru/" target="_blank">
          mos.ru
        </Link>
      </Paragraph>
    ),
  },
  {
    anchor: 'infoAbout7',
    title: 'Причины отказа',
    text: (
      <Fragment>
        <Heading level={5} className="InfoAboutService__contentTitle">
          Основаниями для отказа в приеме запроса или документов, необходимых
          для предоставления государственной услуги, являются:
        </Heading>
        <List className="InfoAboutService__orderedList" ordered>
          <List.Item className="InfoAboutService__orderedListItem">
            Некорректное заполнение обязательных полей в интерактивной форме
            запроса, поданного с использованием Портала.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Обращение за предоставлением государственной услуги уже
            зарегистрировано.
          </List.Item>
        </List>
        <Heading level={5} className="InfoAboutService__contentTitle">
          Основаниями для отказа в предоставлении государственной услуги
          являются:
        </Heading>
        <List className="InfoAboutService__orderedList" ordered>
          <List.Item className="InfoAboutService__orderedListItem">
            Представление запроса и (или) документов, необходимых для
            предоставления государственной услуги, не соответствующих
            требованиям, установленным правовыми актами Российской Федерации,
            правовыми актами города Москвы, Едиными требованиями,
            Административным регламентом, если указанные обстоятельства были
            установлены ГКУ города Москвы «Социальное казначейство города
            Москвы» в процессе обработки документов и (или) информации,
            необходимых для предоставления государственной услуги.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Утрата силы представленных документов (если срок действия документов
            указан в самих документах либо определен законодательством
            Российской Федерации, правовыми актами города Москвы), если
            указанные обстоятельства были установлены ГКУ города Москвы
            «Социальное казначейство города Москвы» в процессе обработки
            сведений и (или) документов, необходимых для предоставления
            государственной услуги.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Наличие в представленных запросе и (или) документах противоречивых
            либо недостоверных сведений, если указанные обстоятельства были
            установлены ГКУ города Москвы «Социальное казначейство города
            Москвы» в процессе обработки запроса и (или) документов, необходимых
            для предоставления государственной услуги.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Противоречие документов или сведений, полученных с использованием
            межведомственного информационного взаимодействия, включая
            использование сведений Базового регистра, представленным заявителем
            сведениям, указанным в запросе, и (или) документам.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Отсутствие у заявителя права на предоставление государственной
            услуги.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Представление неполного комплекта документов, указанных в настоящем
            Регламенте в качестве документов, подлежащих обязательному
            представлению заявителем, если указанное обстоятельство было
            установлено ГКУ города Москвы «Социальное казначейство города
            Москвы» в процессе обработки документов и (или) сведений,
            необходимых для предоставления государственной услуги.
          </List.Item>
          <List.Item className="InfoAboutService__orderedListItem">
            Истечение срока приостановления предоставления государственной
            услуги, если в течение данного срока заявителем не предоставлены в
            МФЦ на бумажном носителе документы, указанные в уведомлении о
            приостановлении предоставления государственной услуги.
          </List.Item>
        </List>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout8',
    title: <Trans>Порядок обжалования</Trans>,
    text: (
      <Fragment>
        <Paragraph className="InfoAboutService__contentText">
          Заявитель имеет право подать в досудебном (внесудебном) порядке жалобу
          на принятые (совершенные) при предоставлении государственной услуги
          решения и (или) действия (бездействие) ГКУ города Москвы «Социальное
          казначейство города Москвы», ГБУ МФЦ города Москвы, их должностных
          лиц, ГКУ города Москвы «Социальное казначейство города Москвы»,
          работников МФЦ.
        </Paragraph>

        <Paragraph className="InfoAboutService__contentText">
          <Trans>
            Вы можете{' '}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.mos.ru/feedback/reception/pre-court/"
            >
              отправить сообщение
            </Link>{' '}
            в органы исполнительной власти города Москвы в рамках досудебного
            обжалования.
          </Trans>
        </Paragraph>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout9',
    title: 'Нормативные акты',
    text: (
      <Fragment>
        <Paragraph className="InfoAboutService__contentText">
          <Link
            href="https://www.mos.ru/donm/documents/normativnye-pravovye-akty/view/166568220/"
            target="_blank"
          >
            Закон города Москвы от 23.11.2005 № 60 «О социальной поддержке семей
            с детьми в городе Москве»
          </Link>
        </Paragraph>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout10',
    title: 'Консультирование',
    text: (
      <Fragment>
        <Paragraph className="InfoAboutService__contentText">
          В любом центре госуслуг «Мои документы» города Москвы, ОСЗН района
          города Москвы, УСЗН АО города Москвы
        </Paragraph>
      </Fragment>
    ),
  },
  {
    anchor: 'infoAbout11',
    title: 'Ведомство',
    text: (
      <Fragment>
        <Paragraph className="InfoAboutService__contentText">
          <Link
            rel="nofollow"
            href={'https://www.mos.ru/dszn/'}
            target={'_blank'}
          >
            Департамент труда и социальной защиты населения города Москвы
          </Link>
        </Paragraph>
      </Fragment>
    ),
  },
];
export const banners = [
  {
    url: i18n._(
      t`https://www.mos.ru/otvet-socialnaya-podderjka/lgoti-mnogodetnim-semyam/`
    ),
    type: i18n._(t`Инструкции`),
    title: i18n._(t`Льготы для многодетных семей`),
    link: i18n._(t`Узнать`),
  },
  {
    url: i18n._(
      t`'https://www.mos.ru/otvet-socialnaya-podderjka/list-vse-dlya-semey-s-detmi-denezhnye-vyplaty-lgoty-socialnaya-podderzhka/'`
    ),
    type: i18n._(t`Инструкции`),
    title: i18n._(t`Всё для семей с детьми`),
    link: i18n._(t`Узнать`),
  },
  {
    url: i18n._(t`https://www.mos.ru/services/catalog/cat/54532/item/61532/`),
    type: i18n._(t`Сервис`),
    title: i18n._(t`Услуги для многодетных семей`),
    link: i18n._(t`Получить`),
  },
];
export const personPlaceholder: Record<
  | keyof (typeof PERSON_FIELD_NAME &
      typeof APPLICANT_FIELD_NAME &
      typeof SPOUSE_FIELD_NAME &
      typeof CHILD_FIELD_NAME)
  | 'birthCertificate'
  | string,
  string | { full: string; empty: string }
> = {
  name: i18n._(t`Имя`),
  surname: i18n._(t`Фамилия`),
  patronymic: i18n._(t`Отчество`),
  noPatronymic: i18n._(t`Нет отчества`),
  birthdate: i18n._(t`Дата рождения`),
  email: i18n._(t`Электронная почта`),
  phone: i18n._(t`Контактный телефон`),
  citizenship: i18n._(t`Гражданство`),
  document: i18n._(t`Документ, удостоверяющий личность`),
  birthCertificate: {
    full: i18n._(t`Свидетельство о рождении`),
    empty: i18n._(t`Данные свидетельства о рождени`),
  },
  seriesAndNumber: i18n._(t`Серия и номер`),
  issueDate: i18n._(t`Дата выдачи`),
  issuer: i18n._(t`Кем выдан`),
  divisionCode: i18n._(t`Код подразделения`),
  birthPlace: i18n._(t`Место рождения`),
  changedName: i18n._(t`Имя до перемены`),
  changedSurname: i18n._(t`Фамилия до перемены`),
  changedPatronimic: i18n._(t`Отчество до перемены`),
  changeNameDocIssuer: i18n._(t`Кем выдано свидетельство о перемене имени`),
  deathdate: i18n._(t`Дата смерти`),
  dateOfMarriage: i18n._(t`Дата заключения брака`),
  dateOfDivorce: i18n._(t`Дата расторжения брака`),
  divorceDocIssuer: i18n._(t`Кем выдано свидетельство о расторжении брака`),
  deathDocIssuer: i18n._(t`Кем выдано свидетельство о смерти`),
};

export const addressPlaceholder = {
  search: i18n._(t`Укажите адрес`),
  region: i18n._(t`Регион`),
  area: i18n._(t`Округ`),
  areaFull: i18n._(t`Округ`),
  areaShort: i18n._(t`Округ`),
  district: i18n._(t`Район`),
  settlement: i18n._(t`Поселение`),
  street: i18n._(t`Улица`),
  house: i18n._(t`Дом/владение`),
  structure: i18n._(t`Строение`),
  building: i18n._(t`Корпус`),
  flat: i18n._(t`Квартира/офис`),
};
export const marriagePlaceholder = {
  date: i18n._(t`Дата заключения брака`),
  number: i18n._(t`Номер записи акта о заключении брака`),
  issuedByWhom: i18n._(t`Кем выдано свидетельство о заключении брака`),
};
export const childCardStatus = {
  fullyFilled: t`Все требуемые сведения о ребёнке внесены`,
  missingParentsInfo: t`Необходима информация о родителях`,
  missingAddressInfo: t`Необходима информация о месте проживания`,
  missingEducationInfo: t`Необходима информация об учебе`,
  missingParentsAndEducationInfo: t`Необходима информация о родителях и учебе`,
  missingParentsAndAddressInfo: t`Необходима информация о родителях и месте проживания`,
  missingParentsAndEducationAndAddressInfo: t`Необходима информация о родителях, учебе и месте проживания`,
  notInMoscow: t`Ребёнок должен быть зарегистрирован в Москве`,
  missingChildInfo: t`Необходима информация о ребёнке`,
  missingPassportInfo: t`Паспорт недействителен`,
};
